import { render, staticRenderFns } from "./attachments-component.vue?vue&type=template&id=8615bcd4&"
import script from "./attachments-component.vue?vue&type=script&lang=ts&"
export * from "./attachments-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports